import React, { Component } from 'react';
import moment from 'moment';
import ZoomInIcon from '../../../assets/img/button-icons/MagnifyingGlassPlus.svg';
import ZoomOutIcon from '../../../assets/img/button-icons/MagnifyingGlassMinus.svg';

import { ItemDotBlueComponent } from './ItemDotBlue';
import { ItemAllIconsComponent } from './ItemAllIcons';
import { ItemDotBlueSmallComponent } from './ItemDotBlueSmall';
import { capitaliseFirst } from './utils/timeline/stringUtils';
import {
  TimelineItemImg,
  TimelineItemAllColours,
  TimelineItemGradient,
  TimelineItemBordered,
} from '.';

import Timeline, {
  TimelineMarkers,
  TodayMarker,
  CustomHeader,
  TimelineHeaders,
} from 'react-calendar-timeline';
import { Container, Stack } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { sendAnalytics } from '../../helpers/analytics';

const oneHour = 60 * 60 * 1000;

export default class PredictionTimeline extends Component {
  constructor(props) {
    super(props);

    this.items = [];
    this.props.items.forEach((x) => this.items.push(Object.assign({}, x)));
    this.showDaysLimit = 100; //days

    let visibleTimeStart = moment().subtract(1, 'week').toDate().valueOf();
    let visibleTimeEnd = moment()
      .endOf('month')
      .add(6, 'month')
      .toDate()
      .valueOf();

    const startDate = moment()
      .subtract(visibleTimeEnd - visibleTimeStart, 'milliseconds')
      .format();
    const days = moment().diff(startDate, 'day');
    const sd = days <= this.showDaysLimit;

    let zoom =
      moment().endOf('month').valueOf() - moment().startOf('month').valueOf();

    // Calculate minTime from the first event or use startDate as fallback
    let minTime = moment(this.props.startDate).valueOf();
    if (this.items && this.items.length > 0) {
      const firstEventTime = Math.min(
        ...this.items.map((item) => item.start_time || Infinity),
      );
      if (firstEventTime !== Infinity) {
        minTime = moment(firstEventTime).valueOf();
      }
    }
    let maxTime = moment(this.props.endDate).endOf('month').valueOf();

    // Starts with groups open
    let openGroups = [];
    let collapsedGroups = {};

    this.props.groups.forEach((g) => {
      openGroups[[g.id]] =
        g.root ||
        this.props.groups.some(
          (gr) => gr.parent === parseInt(g.id) && !gr.root,
        );
    });

    this.state = {
      visibleTimeStart,
      visibleTimeEnd,
      zoom,
      minTime,
      maxTime,
      showDays: sd,
      format: true,
      showHeaders: false,
      openGroups: openGroups,
      collapsedParentGroups: collapsedGroups,
      hasOpenParentGroup: false,
      items: this.items,
    };

    this.groups = this.props.groups;
    this.isSimple = this.props.isSimple;
    this.openInsightDetails = this.props.openInsightDetails;
    this.closeInsightDetails = this.props.closeInsightDetails;
    this.setIsInsightEvent = this.props.setIsInsightEvent;
  }

  componentWillReceiveProps(props) {
    if (props.isSimple !== this.isSimple) {
      this.isSimple = props.isSimple;
    }
  }

  handleCanvasClick = () => {
    this.props.closeInsightDetails();
  };

  handleCanvasContextMenu = () => {};

  handleItemClick = (itemId, _) => {
    if (this.items.find((obj) => obj.id === itemId).type !== 'lineMiddle') {
      if (this.items.find((obj) => obj.id === itemId).insight_id) {
        this.setIsInsightEvent(true);
      } else {
        this.setIsInsightEvent(false);
      }

      this.openInsightDetails(this.items.find((obj) => obj.id === itemId));
    }
  };

  handleItemSelect = (itemId, _, time) => {
    if (this.items.find((obj) => obj.id === itemId).type !== 'lineMiddle') {
      if (this.items.find((obj) => obj.id === itemId).insight_id) {
        this.setIsInsightEvent(true);
      } else {
        this.setIsInsightEvent(false);
      }

      this.openInsightDetails(this.items.find((obj) => obj.id === itemId));
    }
  };

  handleItemDoubleClick = () => {};

  handleItemContextMenu = () => {};

  handleItemMove = (itemId, dragTime, newGroupOrder) => {};

  handleItemResize = (itemId, time, edge) => {
    this.items = this.items.map((item) =>
      item.id === itemId
        ? Object.assign({}, item, {
            start: edge === 'left' ? time : item.start,
            end: edge === 'left' ? item.end : time,
          })
        : item,
    );
  };

  // this limits the timeline to -6 months ... +6 months
  handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
    this.setState({ visibleTimeStart, visibleTimeEnd });
  };

  moveResizeValidator = (action, item, time, resizeEdge) => {
    if (time < new Date().getTime()) {
      var newTime =
        Math.ceil(new Date().getTime() / (15 * 60 * 1000)) * (15 * 60 * 1000);
      return newTime;
    }

    return time;
  };

  onThisYear = () => {
    this.setState((state) => {
      const offset =
        state.visibleTimeEnd - (state.visibleTimeStart + state.zoom);
      this.props.saveDefaultZoom(offset);

      sendAnalytics({
        name: 'This Year',
        attributes: {
          range: `365 days`,
          visibleTimeStart: moment().startOf('month').toDate().valueOf(),
          visibleTimeEnd: moment()
            .endOf('month')
            .add(6, 'month')
            .toDate()
            .valueOf(),
          showDays: JSON.stringify(false),
        },
      });

      return {
        visibleTimeStart: moment().startOf('month').toDate().valueOf(),
        visibleTimeEnd: moment()
          .endOf('month')
          .add(6, 'month')
          .toDate()
          .valueOf(),
        showDays: false,
      };
    });
  };

  onPrevClick = () => {
    this.setState((state) => {
      if (state.minTime < state.visibleTimeStart - state.zoom) {
        return {
          visibleTimeStart: state.visibleTimeStart - state.zoom,
          visibleTimeEnd: state.visibleTimeEnd - state.zoom,
        };
      } else {
        return {
          visibleTimeEnd:
            state.visibleTimeEnd - (state.visibleTimeStart - state.minTime),
          visibleTimeStart: state.minTime,
        };
      }
    });
  };

  onNextClick = () => {
    this.setState((state) => {
      if (state.maxTime > state.visibleTimeEnd + state.zoom) {
        return {
          visibleTimeStart: state.visibleTimeStart + state.zoom,
          visibleTimeEnd: state.visibleTimeEnd + state.zoom,
        };
      } else {
        return {
          visibleTimeStart:
            state.visibleTimeStart + (state.maxTime - state.visibleTimeEnd),
          visibleTimeEnd: state.maxTime,
        };
      }
    });
  };

  onZoomIn = () => {
    this.setState((state) => {
      const offset =
        state.visibleTimeEnd - (state.visibleTimeStart + state.zoom);
      const startDate = moment().subtract(offset, 'milliseconds').format();
      const months = moment().diff(startDate, 'months');
      const days = moment().diff(startDate, 'day');
      if (days > 60) {
        this.props.saveDefaultZoom(offset);
        const showDays = days <= this.showDaysLimit;

        sendAnalytics({
          name: 'Zoom In',
          attributes: {
            range: `${days} days`,
            visibleTimeStart: new Date(
              state.visibleTimeStart + state.zoom,
            ).toISOString(),
            visibleTimeEnd: new Date(
              state.visibleTimeEnd - state.zoom,
            ).toISOString(),
            showDays: JSON.stringify(showDays),
          },
        });

        return {
          visibleTimeStart: state.visibleTimeStart + state.zoom,
          visibleTimeEnd: state.visibleTimeEnd - state.zoom,
          showDays: showDays,
        };
      } else {
        const start = moment(state.visibleTimeEnd)
          .subtract(2, 'months')
          .valueOf();
        const end = moment(state.visibleTimeEnd).valueOf();

        return {
          visibleTimeStart: start,
          visibleTimeEnd: end,
          showDays: true,
        };
      }
    });
  };

  onZoomOut = () => {
    this.setState((state) => {
      const offset =
        state.visibleTimeEnd +
        state.zoom -
        (state.visibleTimeStart - state.zoom);
      const startDate = moment().subtract(offset, 'milliseconds').format();
      const months = moment().diff(startDate, 'months');
      const days = moment().diff(startDate, 'day');
      if (months <= 13) {
        this.props.saveDefaultZoom(offset);
        const showDays = days <= this.showDaysLimit;

        sendAnalytics({
          name: 'Zoom Out',
          attributes: {
            range: `${days} days`,
            visibleTimeStart: new Date(
              state.visibleTimeStart + state.zoom,
            ).toISOString(),
            visibleTimeEnd: new Date(
              state.visibleTimeEnd - state.zoom,
            ).toISOString(),
            showDays: JSON.stringify(showDays),
          },
        });

        return {
          visibleTimeStart: state.visibleTimeStart - state.zoom,
          visibleTimeEnd: state.visibleTimeEnd + state.zoom,
          showDays: showDays,
        };
      }
    });
  };

  gotoMinTime = () => {
    this.setState((state) => {
      return {
        visibleTimeEnd:
          state.visibleTimeEnd - (state.visibleTimeStart - state.minTime),
        visibleTimeStart: state.minTime,
      };
    });
  };

  gotoMaxTime = () => {
    this.setState((state) => {
      return {
        visibleTimeStart:
          state.visibleTimeStart + (state.maxTime - state.visibleTimeEnd),
        visibleTimeEnd: state.maxTime,
      };
    });
  };

  toggleGroup = (id) => {
    const { openGroups, collapsedParentGroups } = this.state;
    var newOpenGroups = { ...openGroups, [id]: !openGroups[id] };
    var newCollapsedGroups = { ...collapsedParentGroups, [id]: openGroups[id] };
    var has = this.groups.some(
      (g) =>
        newOpenGroups[parseInt(g.id)] &&
        this.groups.some((gr) => gr.parent === g.id && !gr.root),
    );

    this.setState({
      openGroups: newOpenGroups,
      collapsedParentGroups: newCollapsedGroups,
      hasOpenParentGroup: has,
    });
  };

  generateNestedTreeView = (group, openGroups, hasChildren) => {
    if (group.root && hasChildren) {
      return (
        <div
          onClick={() => this.toggleGroup(parseInt(group.id))}
          style={{ cursor: 'pointer' }}
          className={
            openGroups[parseInt(group.id)]
              ? 'labelSimple expanded'
              : 'labelSimple'
          }
        >
          <span className="arrowCollapse" style={{ marginRight: 10 }}>
            <i
              className={`fa-solid fa-chevron-${
                openGroups[parseInt(group.id)] ? 'up' : 'down'
              } fa-lg`}
            ></i>
          </span>
          {capitaliseFirst(group.title)}
        </div>
      );
    } else if (!group.root && hasChildren) {
      return (
        <div
          onClick={() => this.toggleGroup(parseInt(group.id))}
          style={{ cursor: 'pointer', paddingLeft: 26 }}
          className={
            openGroups[parseInt(group.id)]
              ? 'labelSimple expanded '
              : 'labelSimple expanded'
          }
        >
          <span className="arrowCollapse" style={{ marginRight: 10 }}>
            <i
              className={`fa-solid fa-chevron-${
                openGroups[parseInt(group.id)] ? 'up' : 'down'
              } fa-lg`}
            ></i>
          </span>
          {capitaliseFirst(group.title)}
        </div>
      );
    } else if (group.root && !hasChildren) {
      return (
        <div className="labelSimple" style={{ paddingLeft: 26 }}>
          {capitaliseFirst(group.title)}
        </div>
      );
    } else {
      return (
        <div
          className="labelGrey"
          style={{
            paddingLeft: 54,
            fontSize: 12,
            height: 40,
            overflow: 'hidden',
          }}
        >
          {capitaliseFirst(group.title)}
        </div>
      );
    }
  };

  verticalLineClassNamesForTime = (timeStart, timeEnd) => {
    const currentTimeStart = moment(timeStart);
    const currentTimeEnd = moment(timeEnd);

    let classes = [];

    const monthStart = moment().startOf('month');
    const monthEnd = moment().startOf('month').add(1, 'month');
    if (currentTimeStart >= monthStart && currentTimeEnd <= monthEnd) {
      classes.push('currentMonthMarker');
    }

    return classes;
  };

  itemRenderer = ({ item, getItemProps }) => {
    function getBgCharacteristics(item) {
      let style = {
        background: 'transparent',
        borderWidth: '0px',
        borderStyle: 'solid',
        borderColor: 'transparent',
        width: '0px',
        borderRadius: '20px',
        zIndex:
          item.type === 'dotBlue' || 'dotDarkBlue' || 'dotPurple' ? 1000 : 999,
      };

      const itemWidth = parseInt(getItemProps().style.width);

      if (
        item.type == 'redBell' ||
        item.type == 'yellowBell' ||
        item.type == 'greenBell' ||
        item.type == 'shield'
      ) {
        style.marginTop = '8px';
      }

      switch (item.type) {
        case 'redBell':
          style.borderWidth = '8px';
          style.borderStyle = 'solid';
          style.borderColor = 'rgba(255,0,0,0.09)';
          style.display = 'flex';
          style.alignItems = 'center';
          style.justifyContent = 'center';
          break;
        case 'greenBell':
          style.borderWidth = '8px';
          style.borderStyle = 'solid';
          style.borderColor = 'rgba(0,255,0,0.32)';
          style.display = 'flex';
          style.alignItems = 'center';
          style.justifyContent = 'center';
          break;
        case 'yellowBell':
          style.borderWidth = '8px';
          style.borderStyle = 'solid';
          style.borderColor = 'rgba(255,255,0,0.32)';
          style.display = 'flex';
          style.alignItems = 'center';
          style.justifyContent = 'center';
          break;
        case 'shield':
          style.background = 'rgba(206,206,206,0.32)';
          style.borderWidth = '0px';
          style.borderStyle = 'none';
          style.display = 'flex';
          style.alignItems = 'center';
          style.justifyContent = 'center';
          break;
        default:
          break;
      }

      if (
        item.action_status === 'E' ||
        item.action_status === 'A' ||
        item.action_status === 'D' ||
        item.action_status === 'C' ||
        item.action_status === 'I'
      ) {
        style.borderWidth = '0px';
        style.borderStyle = 'none';
      }

      if (
        item.type === 'redBell' ||
        item.type === 'yellowBell' ||
        item.type === 'greenBell' ||
        item.type === 'shield'
      ) {
        if (
          item.action_status === 'E' ||
          item.action_status === 'A' ||
          item.action_status === 'D' ||
          item.action_status === 'C' ||
          item.action_status === 'I'
        ) {
          style.background = 'rgba(206,206,206,0.32)';
        } else {
          style.background = 'rgba(235,235,235,0.32)';
        }
        style.background =
          itemWidth < 30 && item.action_status !== 'I'
            ? 'transparent'
            : style.background;
      }

      if (item.type === 'shield') {
        style.maxHeight = '35x';
        style.marginTop = '10px';
      }

      if (item.action_status === 'I') {
        style.marginTop = '15px';
        style.maxHeight = '25px';
      }

      return style;
    }

    // const backgroundColor = itemContext.selected ? itemContext.dragging ? 'red' : item.selectedBgColor : item.bgColor;
    const itemStyle = getBgCharacteristics(item);
    // const borderColor = itemContext.resizing ? 'red' : item.color;

    function removeBracesAndQuotes(inputString) {
      return inputString.replace(/[{}"]/g, '');
    }
    function getShortSummary(item) {
      if (item.pd_dispense_record_link) {
        return 'Medication picked up';
      } else if (item.pd_prescription_record_link) {
        return 'Medication prescribed';
      } else if (String(item.group_type).startsWith('Appointment')) {
        return 'Appointment attendance';
      } else if (item.group_type == 'Diagnostic and Pathology') {
        return 'Diagnostic/Pathology event';
      } else if (item.group_type == 'Other Services') {
        return 'Other service event';
      } else if (String(item.group_type).startsWith('MBS')) {
        return 'Uncategorised MBS event';
      } else if (String(item.group_type).startsWith('Meds')) {
        return 'Medication picked up';
      } else if (String(item.group_type).startsWith('Profile')) {
        return item.interaction_type;
      } else if (item.group_type === 'Insights') {
        return item.why_created;
      } else if (item.detail) {
        return item.detail.description || item.event_name;
      } else {
        return 'No detailed information';
      }
    }

    return (
      <div
        {...getItemProps({
          style: itemStyle,
        })}
      >
        {item.type === 'dotBlue' && (
          <div data-tip data-for={'item-' + item.id}>
            <ItemDotBlueComponent
              item={item}
              isSimple={this.isSimple}
              isExpanded={this.state.openGroups[parseInt(item.group)]}
            ></ItemDotBlueComponent>
            <ReactTooltip id={'item-' + item.id}>
              <span>{getShortSummary(item)}</span>
            </ReactTooltip>
          </div>
        )}

        {(item.type === 'redBell' ||
          item.type === 'yellowBell' ||
          item.type === 'greenBell' ||
          item.type === 'shield') &&
          item.action_status !== 'I' && (
            <div data-tip data-for={'item-' + item.id}>
              <TimelineItemImg
                item={item}
                isSimple={this.isSimple}
                isExpanded={
                  this.state.openGroups[parseInt(item.group)] ? true : false
                }
              ></TimelineItemImg>
              <ReactTooltip id={'item-' + item.id}>
                <span>{getShortSummary(item)}</span>
              </ReactTooltip>
            </div>
          )}

        {(item.type === 'greenZ' ||
          item.type === 'yellowZ' ||
          item.type === 'greenArrowUp' ||
          item.type === 'redZ' ||
          item.type === 'notesCircle' ||
          item.type === 'bell' ||
          item.type === 'redArrowUp' ||
          item.type === 'redArrowDown' ||
          item.type === 'yellowArrowDown' ||
          item.type === 'eye') && (
          <div data-tip data-for={'item-' + item.id}>
            <TimelineItemImg
              item={item}
              isSimple={this.isSimple}
              isExpanded={
                this.state.openGroups[parseInt(item.group)] ? true : false
              }
            ></TimelineItemImg>
            <ReactTooltip id={'item-' + item.id}>
              <span>{getShortSummary(item)}</span>
            </ReactTooltip>
          </div>
        )}

        {(item.type === 'dotDarkBlue' ||
          item.type === 'dotGrey' ||
          item.type === 'dotDiagnostic' ||
          item.type === 'dotPurple' ||
          item.type === 'dotMedProfile' ||
          item.type === 'prescription') && (
          <div data-tip data-for={'item-' + item.id}>
            <TimelineItemAllColours
              item={item}
              isSimple={this.isSimple}
              isExpanded={
                this.state.openGroups[parseInt(item.group)] ||
                (this.groups.find((g) => g.id === item.group) &&
                  this.state.openGroups[
                    parseInt(
                      this.groups.find((g) => g.id === item.group).parent,
                    )
                  ])
                  ? true
                  : false
              }
            ></TimelineItemAllColours>
            <ReactTooltip id={'item-' + item.id}>
              <span>{getShortSummary(item)}</span>
            </ReactTooltip>
          </div>
        )}
        {item.type === 'allIcons' && (
          <ItemAllIconsComponent
            item={item}
            isSimple={this.isSimple}
            isExpanded={
              this.state.openGroups[parseInt(item.group)] ? true : false
            }
          ></ItemAllIconsComponent>
        )}
        {item.type === 'dotBlueSmall' && (
          <ItemDotBlueSmallComponent
            item={item}
            isSimple={this.isSimple}
            isExpanded={
              this.state.openGroups[parseInt(item.group)] ? true : false
            }
          ></ItemDotBlueSmallComponent>
        )}

        {(item.type === 'redBorder' ||
          item.type === 'yellowBorder' ||
          item.type === 'transparentBorder') && (
          <TimelineItemBordered
            item={item}
            isSimple={this.isSimple}
            isExpanded={
              this.state.openGroups[parseInt(item.group)] ? true : false
            }
          ></TimelineItemBordered>
        )}

        {(item.type === 'gradientGreenZ' ||
          item.type === 'gradientYellowZ' ||
          item.type === 'gradientRedZ') && (
          <TimelineItemGradient
            key={item.id}
            item={item}
            isSimple={this.isSimple}
            isExpanded={
              this.state.openGroups[parseInt(item.group)] ? true : false
            }
          ></TimelineItemGradient>
        )}

        {(item.type === 'lineMiddle' || item.type === 'lineMiddle3') && (
          <TimelineItemAllColours
            item={item}
            isSimple={this.isSimple}
            isExpanded={
              this.state.openGroups[parseInt(item.group)] ||
              (this.groups.find((g) => g.id === item.group) &&
                this.state.openGroups[
                  parseInt(this.groups.find((g) => g.id === item.group).parent)
                ])
                ? true
                : false
            }
          ></TimelineItemAllColours>
        )}
      </div>
    );
  };

  groupRenderer = ({ group }) => {
    return (
      <div className="flexVertWrap">
        <div className="flexItem">{group.title}</div>
      </div>
    );
  };

  render() {
    this.groups = this.props.groups;
    this.items = this.props.items;
    this.timeController = this.props.timeController;

    const {
      openGroups,
      visibleTimeStart,
      visibleTimeEnd,
      collapsedParentGroups,
      items,
    } = this.state;

    const tempGroups = this.groups;

    function getParentGroupId(child) {
      const out = tempGroups.find((x) => x.id == child)?.parent;
      return out;
    }

    const relatedCollapsedGroups = [];
    this.groups
      .filter((g) => collapsedParentGroups[g.parent])
      .map((dg) => {
        return {
          children: [dg, ...this.groups.filter((f) => f.parent === dg.id)],
        };
      })
      .forEach((d) => {
        relatedCollapsedGroups.push(...d.children);
      });

    //perform any wrapping in and out of collapsed groups before declaring groups and rendering..
    let newItems = items;
    Object.entries(collapsedParentGroups).forEach((g) => {
      const rootRelatives = relatedCollapsedGroups.filter(
        (x) => x.rootId == g[0],
      );
      if (g[1]) {
        rootRelatives.forEach((r) => {
          const matches = newItems.filter((it) => it.group == r.id);
          matches.map((item) => {
            item.original_group = item.group;
            item.group = Number.parseInt(g[0]); //
            return item; // rollup to parent
          });
        });
        if (rootRelatives.length == 0) {
          const matches = newItems.filter(
            (it) => getParentGroupId(it.group) === Number.parseInt(g[0]),
          );
          matches.map((item) => {
            item.original_group = item.group;
            item.group = getParentGroupId(item.group); //
            return item; // rollup to parent
          });
        }
      } else {
        const matches = newItems.filter(
          (it) => it.group === Number.parseInt(g[0]),
        );
        matches.map((item) => {
          item.group = this.items.find((x) => x.id === item.id).group;
          return item;
        });
      }
    });

    const newGroups = this.groups
      .filter((g) => g.root || openGroups[g.parent])
      .map((group) => {
        var hasChildren = this.groups.some(
          (gr) => gr.parent === parseInt(group.id) && !gr.root,
        );
        return Object.assign({}, group, {
          title: this.generateNestedTreeView(group, openGroups, hasChildren),
        });
      })
      .filter((g) => !relatedCollapsedGroups.find((x) => x.id === g.id));

    return (
      <div>
        <Container fluid>
          <div id="divOverHeader" className="flexHoriz">
            <div className="flexItem">
              <span className="heading1 mr-1">Predictions</span>
            </div>
            <div className="flexItem">
              <Stack direction="horizontal" gap={2}>
                <a onClick={this.onZoomOut}>
                  <img
                    src={ZoomOutIcon}
                    style={{ width: '18px' }}
                    alt="Zoom out icon"
                  ></img>
                </a>
                <a onClick={this.onZoomIn}>
                  <img
                    src={ZoomInIcon}
                    style={{ width: '18px' }}
                    alt="Zoom out icon"
                  ></img>
                </a>
                <a onClick={this.gotoMinTime}>
                  <i className="fa-solid fa-backward-step fa-lg"></i>
                </a>
                <a onClick={this.onPrevClick}>
                  <i className="fa-solid fa-backward fa-lg"></i>
                </a>
                <a onClick={this.onNextClick}>
                  <i className="fa-solid fa-forward fa-lg"></i>
                </a>
                <a onClick={this.gotoMaxTime}>
                  <i className="fa-solid fa-forward-step fa-lg"></i>
                </a>
                <a
                  onClick={this.onThisYear}
                  className="btn btnGrey btn-sm btn-xs"
                >
                  This year
                </a>
              </Stack>
            </div>
          </div>
        </Container>

        {this.items.length > 0 && (
          <Timeline
            groups={newGroups}
            items={newItems}
            sidebarWidth={250}
            sidebarContent={<div>Above The Left</div>}
            canMove={false}
            canResize="right"
            canSelect={true}
            itemsSorted
            itemTouchSendsClick={true}
            stackItems
            itemHeightRatio={1}
            lineHeight={40}
            showCursorLine
            visibleTimeStart={visibleTimeStart}
            visibleTimeEnd={visibleTimeEnd}
            itemRenderer={this.itemRenderer}
            groupRenderer={this.groupRenderer}
            onCanvasClick={this.handleCanvasClick}
            onCanvasContextMenu={this.handleCanvasContextMenu}
            onItemClick={this.handleItemClick}
            onItemSelect={this.handleItemSelect}
            onItemMove={this.handleItemMove}
            onItemResize={this.handleItemResize}
            onItemDoubleClick={this.handleItemDoubleClick}
            onTimeChange={this.handleTimeChange}
            moveResizeValidator={this.moveResizeValidator}
            horizontalLineClassNamesForGroup={(group) =>
              group.root && !openGroups[parseInt(group.id)]
                ? ['rowParent']
                : ['rowChild']
            }
            verticalLineClassNamesForTime={this.verticalLineClassNamesForTime}
          >
            <TimelineMarkers>
              <TodayMarker interval={oneHour}>
                {({ styles, date }) => {
                  const newStyles = {
                    ...styles,
                    width: '1px',
                    backgroundColor: 'transparent',
                    borderLeft: '1px dashed #654B78',
                    zIndex: '50',
                  };
                  return (
                    <div
                      className="flexVert"
                      style={newStyles}
                      ref={this.divRef}
                    >
                      <div
                        className="flexHoriz flexItem"
                        style={{ alignItems: 'flex-start' }}
                      >
                        <div
                          className="dotDayMarker"
                          style={{ marginTop: '0px' }}
                        ></div>
                      </div>
                      <div
                        className="flexHoriz flexItem"
                        style={{ alignItems: 'flex-end' }}
                      >
                        <div
                          className="dotDayMarker"
                          style={{ marginBottom: '0px' }}
                        ></div>
                      </div>
                    </div>
                  );
                }}
              </TodayMarker>
            </TimelineMarkers>

            <TimelineHeaders>
              <CustomHeader unit="year">
                {({
                  headerContext: { intervals },
                  getRootProps,
                  getIntervalProps,
                  showPeriod,
                }) => {
                  return (
                    <div {...getRootProps()}>
                      {intervals.map((interval) => {
                        const intervalStyle = {
                          lineHeight: '30px',
                          // textAlign: 'center',
                          cursor: 'pointer',
                          fontFamily:
                            '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                          fontSize: '15px',
                          fontWeight: 'bold',
                        };
                        return (
                          <div
                            onClick={() => {
                              showPeriod(interval.startTime, interval.endTime);
                              this.setState({ showDays: false });
                            }}
                            {...getIntervalProps({
                              interval,
                              style: intervalStyle,
                            })}
                          >
                            <div className="sticky">
                              {interval.startTime.format('YYYY')}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              </CustomHeader>

              <CustomHeader unit="month">
                {({
                  headerContext: { intervals },
                  getRootProps,
                  getIntervalProps,
                  showPeriod,
                }) => {
                  return (
                    <div {...getRootProps()}>
                      {intervals.map((interval) => {
                        const intervalStyle = {
                          lineHeight: '25px',
                          textAlign: 'center',
                          cursor: 'pointer',
                          fontFamily:
                            '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                          fontSize: '13px',
                          fontWeight: 'bold',
                        };
                        return (
                          <div
                            onClick={() => {
                              showPeriod(interval.startTime, interval.endTime);
                              this.setState({ showDays: true });
                            }}
                            {...getIntervalProps({
                              interval,
                              style: intervalStyle,
                            })}
                          >
                            <div className="sticky stickyCentered">
                              {interval.startTime.format('MMM')}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              </CustomHeader>

              <CustomHeader>
                {({
                  headerContext: { intervals },
                  getRootProps,
                  getIntervalProps,
                  showPeriod,
                }) => {
                  return (
                    <div {...getRootProps()} className="dayHeader">
                      {intervals.map((interval) => {
                        const intervalStyle = {
                          lineHeight: '20px',
                          // textAlign: 'center',
                          // cursor: 'pointer',
                          fontFamily:
                            '"Roboto Condensed",Helvetica,Arial,"sans-serif"',
                          fontSize: '11px',
                          fontWeight: 'bold',
                        };
                        return (
                          <div
                            //onClick={() => {
                            //  showPeriod(interval.startTime, interval.endTime)
                            //}}
                            {...getIntervalProps({
                              interval,
                              style: intervalStyle,
                            })}
                          >
                            {this.state.showDays &&
                              interval.startTime.format('DD')}
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              </CustomHeader>
            </TimelineHeaders>
          </Timeline>
        )}

        {this.items.length == 0 && (
          <div className="noData">
            <div className="noDataText">No data available at this time.</div>
          </div>
        )}
      </div>
    );
  }
}
